import { ModuleKey } from './types';

// Display metadata for the module rail, upsell card, and Tenant Provisioning checkboxes.
export const MODULE_META: Record<ModuleKey, { label: string; blurb: string }> = {
    accounting: { label: 'Accounting', blurb: 'Chart of accounts, journals, AR/AP and cash position.' },
    inventory: { label: 'Inventory', blurb: 'Stock value, item counts and low-stock alerts.' },
    sales: { label: 'Sales', blurb: 'Month-to-date sales and invoice volume.' },
};

// Canonical gated module set (mirrors backend com.kervolt.pos.common.DashboardModule.keys()).
export const GATED_MODULE_KEYS: ModuleKey[] = ['accounting', 'inventory', 'sales'];

/**
 * Whether a module participates in institution module-gating at all.
 *
 * `enabledModules` only ever holds gated keys, so callers must not treat "absent from
 * enabledModules" as "disabled".
 */
export function isGatedModule(module: ModuleKey): boolean {
    return GATED_MODULE_KEYS.includes(module);
}
